import styled from 'styled-components'

export const ContentWrapperStyled = styled.div`
  margin: 0;
  padding: 0;
  min-height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  position: relative;

  font-family: Inter, sans-serif;
  background-color: #f4f6f6;
`
